import React from 'react';
import { SubHeader, ModalConfirm } from '../../components';
import {
  Grid,
  Row,
  Col,
  Table,
  Tooltip,
  OverlayTrigger,
  Button,
  Modal,
  FormControl,
  Label,
  NavDropdown,
  NavItem,
  Popover,
} from 'react-bootstrap';
import CardTable from 'components/CardTable/CardTable.jsx';
import classes from './ShipmentList.module.scss';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import styled from 'styled-components';
import { compose, Query, Mutation, graphql } from 'react-apollo';
import shipmentListQuery from './graphql/query/shipmentList';
import urijs from 'urijs';
import Moment from 'react-moment';
import assignAdminShipment from './graphql/mutation/assignAdminShipment';
import { client } from '../../../../index';
import adminListQuery from './graphql/query/adminList';
import driverUserListQuery from './graphql/query/driverUserList';
import userTruckListQuery from './graphql/query/userTruckList';
import settingTruckListQuery from './graphql/query/settingTruckList';
import ReactPaginate from 'react-paginate';
import shipmentsUpdateMutation from './graphql/mutation/shipmentsUpdate';
import Select, { Async } from 'react-select';
import assignDriverMutation from './graphql/mutation/assignDriver';
import Autosuggest from 'react-autosuggest';
import reportUrl from 'config/reportUrl';
import assignAgentMutation from './graphql/mutation/assignAgent';
import accountInfoListQuery from './graphql/query/accountInfoList';
import lazadaImportOrderListQuery from './graphql/query/lazadaImportOrderList';
import customerId from 'config/customerId';
import UploadFile from './components/UploadFile'
import ImportBookingFileModal from '../../components/ImportBookingFileModal'
import shipmentTrackingJd from './graphql/query/shipmentTrackingJd'
import { Link } from 'react-router-dom'
import AdminNameQuery from 'utils/AdminName/graphql/query/adminList'

const NavDropdownContainer = styled(NavDropdown)`
  list-style: none;
  float: left;
  margin-left: 5px;

  & a {
    & .caret {
      display: none;
    }

    & button.btn.btn-default {
      float: left;
      padding: 5px 8px;
    }
  }
`;
const Tag = styled.div`
    background-color: #E5FFE5;
    color: #5DBA5B;
    font-weight: bold;
    padding: 2px 5px;
    margin-left: 30px;
    border-radius: 4px;
`;
const Line = styled.div`
    height: 36px;
    width: 0px;
    margin: 0px 20px;
    border-left: 1px solid #E3E3E3;
`;
const MenuWrapper = styled.div`
  width: 100%;
  & ul{
    padding-left: 0;
    margin: 0;
    display: flex;

    & li{
      list-style: none;
      margin-right: 15px;
      padding: 22px 10px 15px;

      & a{
        font-size:18px;
        cursor: pointer;
        color: #000000;
        & i{
          font-size:18px;
          color: #000000;
        }
      }
    }
    & li.active{
      border-bottom: 2px solid #d90402;
    }
    
  }
`;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  float: right;

  & .text {
    padding: 5px;
  }
  & .form-control {
    padding: 6px 10px;
    height: 30px;
    width: 70px;
  }
`;

const NavItemDropDownList = styled(NavItem)``;
const AutosuggestContainer = styled.div`
  & .react-autosuggest__suggestions-list {
    list-style: none;
    color: #000000;
    padding: 0;
    margin: 0;
    border: 1px solid #e3e3e3;
    margin-top: 0px;
    border-radius: 4px;

    position: absolute;
    background-color: white;
    z-index: 999;
    min-width: 150px;
    white-space: nowrap;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  }

  & .react-autosuggest__suggestion {
    padding: 10px 10px;
    background-color: #ffffff;
    cursor: pointer;

    &:hover {
      background-color: #e3e3e3;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #e3e3e3;
    }
  }

  & .react-autosuggest__suggestion--highlighted {
    background-color: #e3e3e3;
  }
`;

const rejectList = [
  { value: 'ทดสอบ', label: 'ทดสอบ' },
  { value: 'ลูกค้ายกเลิกงาน', label: 'ลูกค้ายกเลิกงาน' },
  { value: 'เปลี่ยนเส้นทาง', label: 'เปลี่ยนเส้นทาง' },
  { value: 'เปลี่ยนวันใช้งาน', label: 'เปลี่ยนวันใช้งาน' },
  { value: 'เปลี่ยนประเภทรถ', label: 'เปลี่ยนประเภทรถ' },
  { value: 'ไม่ตรงตามเงื่อนไข', label: 'ไม่ตรงตามเงื่อนไข' },
  { value: 'ไม่พร้อมให้บริการ', label: 'ไม่พร้อมให้บริการ' },
  { value: 'ลูกค้าจองซ้ำ', label: 'ลูกค้าจองซ้ำ' },
  { value: 'ไม่สามารถติดต่อลูกค้าได้', label: 'ไม่สามารถติดต่อลูกค้าได้' },
  {
    value: 'ลูกค้าต้องการใช้บริการเสริม',
    label: 'ลูกค้าต้องการใช้บริการเสริม',
  },
  { value: 'เลือกใช้บริการเจ้าอื่น', label: 'เลือกใช้บริการเจ้าอื่น' },
  { value: 'อื่นๆ', label: 'อื่นๆ' },
];

class ShipmentList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shipment_list: [],
      order_by: null,
      order_type: null,
      shipmentName: '',
      shipment_number: '',
      tagName: '',
      commodityName: '././.',
      pickupDate: '',
      displayPickupDate: '',
      lastupdateDate: '',
      displayLastupdateDate: '',
      shipmentStatus: 0,
      shipmentRunningNumber: '',
      admin: '',
      createDate: '',
      displayCreateDate: '',
      pageNumber: 1,
      lazadaImportOrderId: null,
      lazadaImportOrderName: '',
      lazadaImportOrderPickupDate: null,
      show_data: 30,
      trackingNumber: '',
      trackingNumberForSearch: '',

      //ค้นหา driver
      driverUserListSuggestions: [],
      driverName: '',
      driverId: '',
      setting_truck_type_id: '',

      //assign admin
      isOpenModalAssignAdmin: false,
      shipmentID: '',
      shipmentNumber: '',
      adminName: '',

      //cancel shipment
      rejectDetail: '',
      isShowRejectDetail: false,
      rejectSelected: null,
      rejectRemark: '',
      isOpenModalConfirmCancel: false,

      //assign driver
      driverUserId: '',
      userSettingTruckId: '',
      isOpenModalAssignDriver: false,
      driverSelected: '',
      truckSelected: '',

      DriverSuggestions: [],
      TruckSuggestions: [],

      fileNameBookingFile: '',
      isOpenModalConfirmDownloadReport: false,
      idBookingFile: null,

      //assign agent
      agentSelected: null,
      agentId: '',
      isOpenModalAssignAgent: false,

      //import booking file 
      isOpenImportBookingFileModal: false,

      OrderNumber: '',
      
    };
      this._inputImportFile1 = React.createRef();
  }

  componentDidMount() {
    this.fetchDataLazadaImportOrderList();
  }

  fetchDataLazadaImportOrderList = async () => {
    try {
      const id = this.getIdFromUrl();

      if (!id) {
        return;
      }

      const { data } = await client.query({
        query: lazadaImportOrderListQuery,
        variables: {
          lazada_import_order_id: id,
          account_info_id: customerId.lazada,
        },
      });

      const { order } = data.lazadaImportOrderList;

      if (order.length === 1) {
        const { _id, pick_up_date, name } = order[0];
        this.setState({
          lazadaImportOrderId: _id,
          lazadaImportOrderName: name,
          lazadaImportOrderPickupDate: pick_up_date,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  getIdFromUrl = () => {
    const id = urijs(window.location.href).query(true).id;
    return id;
  };

  renderStatus(status) {
    switch (status) {
      case 2:
        return <Label bsStyle="default">รอขนส่งรับงาน</Label>;
      case 10:
        return <Label bsStyle="primary">รอเริ่มงาน</Label>;
      case 3:
        return <Label bsStyle="primary">กำลังดำเนินการขนส่ง</Label>;
      case 4:
        return <Label bsStyle="success">เสร็จสิ้นแล้ว</Label>;
      case 5:
        return <Label bsStyle="danger">ถูกยกเลิก</Label>;
      case 6:
        return <Label bsStyle="warning">งานเกิดปัญหา</Label>;
      case 7:
        return <Label bsStyle="default">แบบร่าง</Label>;
      case 8:
        return <Label bsStyle="primary">นัดหมายลูกค้าแล้ว</Label>;
      case 9:
        return <Label bsStyle="primary">กำลังคืนคลัง</Label>;
      default:
        return '';
    }
  }

  renderLazadaSendFinalStatus(status, key) {
    switch (status) {
      case 1:
        return (
          <Label bsStyle="warning">
            <i className="fas fa-spinner"></i>
          </Label>
        );
      case 2:
        return (
          <Label bsStyle="success">
            <i className="fas fa-check"></i>
          </Label>
        );
      default:
        return (
          <Label bsStyle="danger">
            <i className="fas fa-times"></i>
          </Label>
        );
    }
  }

  handleDateRangePicker(mode, picker) {
    const date = `${picker.startDate.format('YYYY-MM-DD')}:${picker.endDate.format('YYYY-MM-DD')}`;

    const display = `${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format(
      'DD/MM/YYYY'
    )}`;
    if (mode === 'lastupdateDate') {
      this.setState({ lastupdateDate: date, displayLastupdateDate: display });
    } else if (mode === 'pickupDate') {
      this.setState({ pickupDate: date, displayPickupDate: display });
    }
  }

  handleShowAssignAdmin = async (shipmentID, shipmentNumber) => {
    try {
      const { data } = await client.query({
        query: adminListQuery,
      });

      const { admin } = data.adminList;

      if (admin.length === 0) {
        alert('ไม่พบ Admin');
        return;
      }

      this.setState({
        adminName: admin[0].admin_username,
        isOpenModalAssignAdmin: true,
        shipmentID: shipmentID,
        shipmentNumber: shipmentNumber,
      });
    } catch (error) {
      alert(error);
    }
  };

  renderViewDriver(driverId, driverList) {
    if (driverId === null) {
      return '-';
    }

    const driver = driverList.filter(item => item._id === driverId);
    if (driver.length > 0) {
      return `${driver[0].driver_name}, ${driver[0].driver_phone_code} ${driver[0].driver_phone_number}`;
    }
  }

  renderViewTruck(userSettingTruckId, userTruckList) {
    if (userSettingTruckId === null) {
      return '-';
    }

    const truck = userTruckList.filter(item => item._id === userSettingTruckId);
    if (truck.length > 0) {
      return `${truck[0].user_setting_truck_license_plate}`;
    }
  }

  handleChangeReject(event) {
    this.setState({
      rejectSelected: event,
      rejectRemark: event.value,
    });

    if (event.value === 'อื่นๆ') {
      this.setState({ isShowRejectDetail: true });
    } else {
      this.setState({ isShowRejectDetail: false });
    }
  }

  handleCancelShipment = async (shipmentID, shipmentsUpdate) => {
    try {
      this.setState({ isLoading: true });
      const { shipmentID } = this.state;
      const { data } = await client.query({
        query: shipmentListQuery,
        variables: {
          _id: shipmentID,
        },
        fetchPolicy: 'network-only',
      });

      const { shipment } = data.shipmentList;
      if (
        shipment[0].shipment_status === 4 ||
        shipment[0].shipment_status === 5 ||
        shipment[0].shipment_status === 8
      ) {
        this.setState({ isLoading: false, isOpenModalConfirmCancel: false });
        alert('ไม่สามารถยกเลิกรายการได้');
        return;
      }

      shipmentsUpdate();
    } catch (error) {
      this.setState({
        isLoading: false,
        isOpenModalConfirmCancel: false,
      });

      alert(error);
    }
  };

  handleAssignDriver = shipment => {
    const { _id, shipment_number, driver_user_id, user_setting_truck_id } = shipment;
    const shipmentNumber = shipment_number;

    if (driver_user_id) {
      this.setState({
        isOpenModalAssignDriver: true,
        shipmentID: _id,
        shipmentNumber: shipmentNumber,
        driverUserId: driver_user_id,
        userSettingTruckId: user_setting_truck_id,
        driverSelected: `${shipment.driver_name} (0${shipment.driver_phone_number})`,
        truckSelected: shipment.user_setting_truck_license_plate,
      });
    } else {
      this.setState({
        isOpenModalAssignDriver: true,
        shipmentID: _id,
        shipmentNumber: shipmentNumber,
        driverUserId: driver_user_id,
        userSettingTruckId: user_setting_truck_id,
        driverSelected: '',
        truckSelected: '',
      });
    }
  };

  setAgentData = async transporterId => {
    if (!transporterId) {
      return;
    }

    try {
      const { data: accountInfoListData } = await client.query({
        query: accountInfoListQuery,
        variables: {
          _id: transporterId,
        },
      });
      if (accountInfoListData.accountInfoList.account_info.length > 0) {
        const {
          _id,
          account_info_business_name,
        } = accountInfoListData.accountInfoList.account_info[0];

        this.setState({
          agentId: _id,
          agentSelected: { value: _id, label: account_info_business_name },
        });
      }
    } catch (error) {
      alert(error);
    }
  };

  handleAssignAgent = (shipment, agentList) => {
    const { _id, shipment_number, transporter } = shipment;
    const shipmentNumber = shipment_number;
    const agent = agentList.filter(item => item._id === transporter);
    this.clearDataSelectAgent();

    if (agent.length > 0) {
      this.setState({
        isOpenModalAssignAgent: true,
        shipmentID: _id,
        shipmentNumber: shipmentNumber,
        agentSelected: { value: agent[0]._id, label: agent[0].account_info_business_name },
      });
    } else {
      this.setState({
        isOpenModalAssignAgent: true,
        shipmentID: _id,
        shipmentNumber: shipmentNumber,
        agentId: transporter,
      });
    }
  };

  selectOptionDriverList = driverList => {
    return driverList.map(driver => {
      return {
        value: driver._id,
        label:
          driver.driver_name +
          ' (' +
          driver.driver_phone_code +
          '-' +
          driver.driver_phone_number +
          ')',
        user_setting_truck_id: driver.user_setting_truck_id,
        user_setting_truck_license_plate: driver.user_setting_truck_license_plate,
      };
    });
  };

  selectOptionTruckList = userTruckList => {
    return userTruckList.map(truck => {
      return {
        value: truck._id,
        label: truck.user_setting_truck_license_plate,
      };
    });
  };

  selectOptionAgentList = agentList => {
    return agentList.map(agent => {
      return {
        value: agent._id,
        label: agent.account_info_business_name,
      };
    });
  };

  handleChangeDriver(driver, driverList) {
    this.setState(
      {
        driverSelected: driver,
        driverUserId: driver.value,
        truckSelected: {
          value: driver.user_setting_truck_id,
          label: driver.user_setting_truck_license_plate,
        },
        userSettingTruckId: driver.user_setting_truck_id,
      },
      () => {
        this.clearDataSelectAgent();
        const driverFilter = driverList.filter(item => item._id === driver.value);
        this.setAgentData(driverFilter[0].account_info_id);
      }
    );
  }

  handleChangeAgent = agent => {
    this.setState({ agentSelected: agent, agentId: agent.value });
  };

  handleChangeTruck(truck) {
    this.setState({ truckSelected: truck, userSettingTruckId: truck.value });
  }

  getSuggestions = async value => {
    const inputValue = value
      .trim()
      .toString()
      .toLowerCase();

    try {
      const { data } = await client.query({
        query: driverUserListQuery,
        fetchPolicy: 'network-only',
        variables: {
          driver_name: inputValue,
        },
      });

      const driverUserListData = data.driverUserList.driver_user.map(e => {
        return {
          id: e._id,
          name: e.driver_name,
        };
      });

      this.setState({
        driverUserListSuggestions: driverUserListData,
      });
    } catch (error) {
      console.log(error);
    }
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      driverUserListSuggestions: [],
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.getSuggestions(value);
  };

  getSuggestionValue = suggestion => suggestion.name;

  renderSuggestion = suggestion => <div key={suggestion.id}>{suggestion.name}</div>;

  shouldRenderSuggestions() {
    return true;
  }

  downloadReportHandler = async () => {
    try {
      const { data } = await client.query({
        query: adminListQuery,
      });

      const { admin } = data.adminList;

      if (admin.length === 0) {
        alert('ไม่พบ Admin');
        return;
      }

      const { idBookingFile } = this.state;
      const adminId = admin[0]._id;
      const url = `${reportUrl}/lazada-summary?id=${idBookingFile}&admin_id=${adminId}`;
      window.open(url, '_blank');
      this.setState({
        isOpenModalConfirmDownloadReport: false,
      });
    } catch (error) {
      alert(error);
    }
  };

  formatMoney = number => {
    return `฿ ${number.toLocaleString('en-US', {
      maximumFractionDigits: 2,
    })}`;
  };

  sort(order_by, refetch) {
    if (order_by == this.state.order_by) {
      this.setState({ order_type: this.state.order_type * -1 });
    } else {
      this.setState({ order_type: 1, order_by });
    }
    refetch();
  }

  renderSorting(order_by) {
    if (order_by == this.state.order_by) {
      if (this.state.order_type == 1) {
        return 'sorting_asc';
      } else {
        return 'sorting_desc';
      }
    }

    return 'sorting';
  }

  clearDataSelectAgent = () => {
    this.setState({
      agentSelected: null,
      agentId: '',
    });
  };

  //Autosuggest Driver
  getSuggestionsDriver = async value => {
    const inputValue = value
      .trim()
      .toString()
      .toLowerCase();
    const inputLength = inputValue.length;

    try {
      const { data } = await client.query({
        query: driverUserListQuery,
        fetchPolicy: 'network-only',
        variables: {
          driver_name: inputValue,
        },
      });

      const driverData = data.driverUserList.driver_user.map(e => {
        return {
          id: e._id,
          name: `${e.driver_name} (0${e.driver_phone_number})`,
          user_setting_truck_id: e.user_setting_truck_id ? e.user_setting_truck_id : '',
          user_setting_truck_license_plate: e.user_setting_truck_license_plate
            ? e.user_setting_truck_license_plate
            : '',
        };
      });

      this.setState({
        DriverSuggestions: driverData,
      });
    } catch (error) {
      console.log(error);
    }
  };

  getSuggestionValueDriver = suggestion => suggestion.name;

  renderSuggestionDriver = suggestion => <div key={suggestion.id}>{suggestion.name}</div>;

  onSuggestionsFetchRequestedDriver = ({ value }) => {
    this.getSuggestionsDriver(value);
  };

  onSuggestionsClearRequestedDriver = () => {
    this.setState({
      DriverSuggestions: [],
    });
  };

  shouldRenderSuggestionsDriver() {
    return true;
  }
  //End Autosuggest Driver

  //Autosuggest Truck
  getSuggestionsTruck = async value => {
    const inputValue = value
      .trim()
      .toString()
      .toLowerCase();
    const inputLength = inputValue.length;

    try {
      const { data } = await client.query({
        query: userTruckListQuery,
        fetchPolicy: 'network-only',
        variables: {
          user_setting_truck_license_plate: inputValue,
        },
      });

      const driverData = data.userSettingTruckList.user_setting_truck.map(e => {
        return {
          id: e._id,
          name: e.user_setting_truck_license_plate,
        };
      });

      this.setState({
        TruckSuggestions: driverData,
      });
    } catch (error) {
      console.log(error);
    }
  };

  getSuggestionValueTruck = suggestion => suggestion.name;

  renderSuggestionTruck = suggestion => <div key={suggestion.id}>{suggestion.name}</div>;

  onSuggestionsFetchRequestedTruck = ({ value }) => {
    this.getSuggestionsTruck(value);
  };

  onSuggestionsClearRequestedTruck = () => {
    this.setState({
      TruckSuggestions: [],
    });
  };

  shouldRenderSuggestionsTruck() {
    return true;
  }
  //End Autosuggest Truck

  //Import File
  openImportFileModal = () => {
    this.setState({
      isOpenImportBookingFileModal: true
    })
  }

  checkFileTypeImage(file) {
    if (file) {
        return file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
        || file.type === "application/vnd.ms-excel";
    }
  }
  
  downloadTemplate (reportUrl) {
      const url = 'https://s3-ap-southeast-1.amazonaws.com/appmedia.giztix.com/upload/template_file/template-export-tracking-status.xlsx';
      window.open(url, '_blank');
  };

  getIdFromUrl = () => {
    return urijs(window.location.href).query(true).id;
  };
  
  renderStatusMode = (status) => {
    switch(status){
      case 1:
        return <span class="label label-success">Last Mile (NM)</span>
      case 2:
        return <span class="label label-danger">Return to Merchant (RM)</span>
      case 3:
        return <span class="label" style={{backgroundColor: '#318DE8'}}>FIRST MILE (FM)</span>
      case 4:
        return <span class="label" style={{backgroundColor: '#FFDB46', color: 'black'}}>SPECIAL (SP)</span>
      case 5:
        return <span class="label" style={{backgroundColor: '#ff9800'}}>Customer Return (CR)</span>
      case 6:
        return <span class="label" style={{backgroundColor: '#82c5b9'}}>Return to WH (RTWH)</span>
      case 7:
        return <span class="label" style={{backgroundColor: '#82c5f9'}}>Return to Customer (CR/RC)</span>
      case 8:
        return <span class="label" style={{backgroundColor: '#FF0505'}}>Return to Merchant (CR/RM)</span>
      case 9:
        return <span class="label" style={{backgroundColor: '#d6949e'}}>Line Haul (LH)</span>
      default:
        return null
    }
  }

  getShipmentList = async () => {
    try {
      const { data } = await client.query({
        query: shipmentListQuery,
        fetchPolicy: 'network-only',
        variables: {
          page_number: this.state.pageNumber,
          order_by: this.state.order_by,
          order_type: this.state.order_type,
          pick_up_date: this.state.pickupDate,
          last_update: this.state.lastupdateDate,
          commodity_name: this.state.commodityName,
        },
      });

      this.setState({
        shipment_list: data.shipmentList.shipment
      })

    } catch (error) {
      console.log(error);
    }
  }

  handleSearch = () => {
    if(this.state.trackingNumber){
      this.setState({
        commodityName: this.state.trackingNumber,
        trackingNumberForSearch: this.state.trackingNumber
      })
      return null
    }
    this.setState({
      commodityName: '././',
      trackingNumberForSearch: '././'
    })
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch()
    }
  }

  render() {
    let adminType = null;
    if (this.props.adminNameQuery.loading == false && this.props.adminNameQuery.adminList != undefined) {
      adminType = this.props.adminNameQuery.adminList.admin[0].admin_user_type;
    }


    return (
      <div className="content">
        <Query
          query={shipmentTrackingJd}
          variables={{
            params: {
              trackingNumber: this.state.commodityName,
              pick_up_date: this.state.pickupDate,
              completed_date: this.state.lastupdateDate
            },
            // sort: {
            //   order_by: this.state.order_by,
            //   order_type: this.state.order_type,
            // },
            page: this.state.pageNumber,
            showData: this.state.show_data,
          }}
          fetchPolicy="cache-and-network"
        >
          {({ data, loading, error, refetch }) => {
            let shipmentList = [];
            let totalPage = 0;

            if (!loading && !error) {
              shipmentList = [...data.shipmentTrackingJd.shipment];
              totalPage = data.shipmentTrackingJd.total_page;
            }

            var itemLength = 'loading';
            const itemIndicatorSize = (this.state.pageNumber - 1) * 30;
            if (data.shipmentTrackingJd) {
              if (data.shipmentTrackingJd.shipment.length > 0) {
                itemLength = data.shipmentTrackingJd.shipment.length;
              }
            }

            return (
              <>
                <Grid fluid>
                  <div>
                    <Row>
                      <Col md={12}>
                          <CardTable
                            ctTableFullWidth
                            ctTableResponsive
                            title="ตารางรายการงานขนส่ง"
                            content={
                              <div>
                                {
                                  // HEADER
                                }
                                  <Row style={{justifyContent: 'space-between'}} >
                                    <Col md={3} >
                                      <strong>Tracking No</strong>
                                        <div style={{display: 'flex', gap: '10px'}} >
                                          <FormControl
                                            type="text"
                                            placeholder="ค้นหาเลข tracking"
                                            value={this.state.trackingNumber}
                                            onKeyDown={this._handleKeyDown}
                                            onChange={event => {
                                              this.setState({
                                                trackingNumber: event.target.value,
                                                pageNumber: 1,
                                              });
                                            }}
                                          />
                                          <Button  onClick={this.handleSearch} >ค้นหา</Button>
                                        </div>
                                    </Col>
                                    <Col md={7} ></Col>
                                    <Col md={2} style={{display: adminType ? (adminType === 6 ? 'block' : 'none') : 'none'} } >
                                      <br/>
                                      <div style={{display: 'flex', justifyContent: 'flex-end'}} >
                                      <Link to="/report" >
                                        <Button>รายงาน</Button>
                                      </Link>
                                      </div>
                                    </Col>
                                  </Row>
                                  {
                                      //  PageWrapper //
                                    // <PageWrapper style={{ textAlign: 'right' }}>
                                    //   <div className="text">
                                    //     {this.state.pageNumber === 1
                                    //       ? `1 - ${itemLength}`
                                    //       : `${itemIndicatorSize + 1} - ${itemLength +
                                    //       itemIndicatorSize}`}{' '}
                                    //     หน้า :
                                    //   </div>
                                    //   <FormControl
                                    //     type="number"
                                    //     min={1}
                                    //     value={this.state.pageNumber}
                                    //     onChange={event =>
                                    //       Number(event.target.value) >= 0
                                    //         ? setInterval(
                                    //           this.setState({
                                    //             pageNumber: Number(event.target.value),
                                    //           }),
                                    //           1000
                                    //         )
                                    //         : setInterval(this.setState({ pageNumber: 1 }), 1000)
                                    //     }
                                    //     name="page_number"
                                    //   />
                                    //   <div className="text">
                                    //     {' '}
                                    //     {
                                    //       loading || error ? '' : `จาก ${data.shipmentTrackingJd.total_page}`
                                    //     }
                                    //   </div>
                                    // </PageWrapper>
                                  }
                                  
                                  {
                                    // TABLE
                                  }
                                  <div className="table-vertical">
                                    <Table striped hover>
                                      <thead>
                                        <tr>
                                          <th style={{ minWidth: '80px' }}>เครื่องมือ</th>
                                          <th
                                            style={{ minWidth: '180px' }}
                                            className={this.renderSorting('shipment_name')}
                                            onClick={() => this.sort('shipment_name', refetch)}
                                          >
                                            Trip Name
                                          </th>
                                          <th style={{ minWidth: '160px' }}>
                                            สถานะ
                                          </th>
                                          <th>mode</th>
                                          <th style={{ minWidth: '160px' }}>วันที่รับสินค้า</th>  
                                          <th style={{ minWidth: '160px' }}>วันที่งานเสร็จสิ้น</th>
                                          <th style={{ minWidth: '160px' }}>พนักงานขับรถ</th>
                                          <th style={{ minWidth: '100px' }}>เลขทะเบียน</th>
                                          <th style={{ minWidth: '100px' }}>จุดรับสินค้า</th>
                                          {
                                            // <th style={{ minWidth: '100px' }}>จุดส่งสินค้า</th>
                                          }
                                          <th style={{ minWidth: '140px' }}>ประเภทรถขนส่ง</th>
                                        </tr>
                                        <tr>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th>                                      
                                            <DateRangePicker
                                              onApply={(event, picker) =>
                                                this.handleDateRangePicker('pickupDate', picker)
                                              }
                                              onCancel={() =>
                                                this.setState({
                                                  pickupDate: '',
                                                  displayPickupDate: '',
                                                  pageNumber: 1,
                                                })
                                              }
                                              containerStyles={{ display: 'block' }}
                                              opens="right"
                                              format="DD/MM/YYYY"
                                            >
                                              <FormControl
                                                type="text"
                                                value={this.state.displayPickupDate}
                                                placeholder="วันที่รับสินค้า"
                                              />
                                            </DateRangePicker>
                                          </th>
                                          <th>                                      
                                            <DateRangePicker
                                              onApply={(event, lastupdate) =>
                                                this.handleDateRangePicker('lastupdateDate', lastupdate)
                                              }
                                              onCancel={() =>
                                                this.setState({
                                                  lastupdateDate: '',
                                                  displayLastupdateDate: '',
                                                  pageNumber: 1,
                                                })
                                              }
                                              containerStyles={{ display: 'block' }}
                                              opens="right"
                                              format="DD/MM/YYYY"
                                            >
                                              <FormControl
                                                type="text"
                                                value={this.state.displayLastupdateDate}
                                                placeholder="วันที่รับสินค้า"
                                              />
                                            </DateRangePicker>
                                          </th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          {
                                            // <th></th>
                                          }
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {loading && (
                                          <tr>
                                            <td colSpan="15">Loading...</td>
                                          </tr>
                                        )}

                                        {error && (
                                          <tr>
                                            <td colSpan="15">Error</td>
                                          </tr>
                                        )}

                                        {!loading && !error && shipmentList.length === 0 && (
                                          <tr>
                                            <td colSpan="15">กรุณาระบุหมายเลข tracking ให้ถูกต้อง</td>
                                          </tr>
                                        )}

                                        {shipmentList.map((item, index) => (
                                          <tr>
                                            <td>
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip">ดูข้อมูล</Tooltip>}
                                              >
                                                <a
                                                  href={`/shipment-detail?id=${item._id}&tracking=${this.state.trackingNumberForSearch}`}
                                                  target="_blank"
                                                  style={{ float: 'left' }}
                                                  className="btn btn-default"
                                                >
                                                  <i
                                                    style={{ marginTop: '3px' }}
                                                    className="fas fa-eye"
                                                  ></i>
                                                </a>
                                              </OverlayTrigger>
                                            </td>
                                            <td>{item.shipment_name}</td>
                                            <td>
                                              {this.renderStatus(item.shipment_status)}{' '}
                                            </td>
                                            <td>
                                              {
                                                this.renderStatusMode(item.lazada_order_type)
                                              }
                                            </td>
                                            <td>
                                              <Moment format="DD/MM/YYYY HH:mm:ss">
                                                {item.pick_up_date}
                                              </Moment>
                                            </td>
                                            <td>
                                            {item.completed_date ? 
                                              <Moment format="DD/MM/YYYY HH:mm:ss">
                                                {item.completed_date}
                                              </Moment> 
                                              : '-'
                                            }
                                            </td>
                                            <td>
                                              {item.driver_name
                                                ? `
                                                ${item.driver_name}, ${item.driver_phone_code} ${item.driver_phone_number}`
                                                : '-'}
                                            </td>
                                            <td>{item.user_setting_truck_license_plate || '-'}</td>
                                            <td>{item.shipment_address[0].tag_name}</td>
                                            {
                                            // <td>
                                            //   <OverlayTrigger
                                            //     trigger="hover"
                                            //     key="bottom"
                                            //     placement="bottom"
                                            //     overlay={
                                            //       <Popover
                                            //         id={`popover-positioned-${item._id}`}
                                            //         title={`จุดส่งสินค้าทั้งหมด ${
                                            //           item.shipment_address.filter(
                                            //             shipmentAddress =>
                                            //               shipmentAddress.mode === 'ส่งสินค้า'
                                            //           ).length
                                            //           } จุด `}
                                            //       >
                                            //         {item.shipment_address
                                            //           .filter(
                                            //             shipmentAddress =>
                                            //               shipmentAddress.mode === 'ส่งสินค้า'
                                            //           )
                                            //           .map((address, key) => (
                                            //             <p>
                                            //               <strong>{`จุดที่ ${key + 1} `}</strong>
                                            //               {`${address.commodity[0].name}`}{' '}
                                            //             </p>
                                            //           ))}
                                            //       </Popover>
                                            //     }
                                            //   >
                                            //     <b style={{ cursor: 'pointer' }}>
                                            //       {`${
                                            //         item.shipment_address.filter(
                                            //           shipmentAddress =>
                                            //             shipmentAddress.mode === 'ส่งสินค้า'
                                            //         ).length
                                            //         } จุดส่ง`}
                                            //     </b>
                                            //   </OverlayTrigger>
                                            // </td>
  }
                                            <td>
                                              {`${item.setting_truck_name.th} ${item.truck_type_name.th}`}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  </div>

                                  {
                                    // PAGINATION
                                  }
                                  <div style={{ textAlign: 'right', marginTop: 20 }}>
                                  {!loading && !error && (
                                    <ReactPaginate
                                      pageCount={totalPage}
                                      forcePage={this.state.pageNumber - 1}
                                      containerClassName="pagination"
                                      nextLabel=">"
                                      previousLabel="<"
                                      onPageChange={({ selected }) => {
                                        this.setState({
                                          pageNumber: selected + 1,
                                        });
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            }
                          />
                      </Col>
                    </Row>
                  </div>
                </Grid>
              </>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default compose(
  graphql(driverUserListQuery, { name: 'driverUserListQuery' }),
  graphql(userTruckListQuery, { name: 'userTruckListQuery' }),
  graphql(accountInfoListQuery, {
    name: 'accountInfoListQuery',
    options: () => ({
      fetchPolicy: 'network-only',
      variables: {
        account_info_type: 3,
      },
    }),
  }),
  graphql(AdminNameQuery, { name: 'adminNameQuery' }),
)(ShipmentList);
